<div *ngIf="location.pricing.loyer > 0">
  {{location.pricing.loyer | appCurrency}}

  <span class="loyer-details">
    / {{location.pricing.periodicite.abreviation}} {{ location.pricing.chargesIncluses ? 'CC' : 'HC' }}
  </span>
</div>

<div *ngIf="location.pricing.loyer <= 0">Pas de loyer saisi</div>
